export default __webpack_public_path__ + "static/media/Ficha_maiz_ZH.09ff5a61.png";